import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import { FORM, LAYOUT_ITEM } from 'constants/FormConstants';
import { TextFieldLayoutItem, SelectLayoutItem } from 'models/InputLayoutItem';
import React, { useState } from 'react';
import { calculateDownPaymentPercent } from 'utils/calculateDownPaymentPercent';
import * as yup from 'yup';


export const NewSimulationForm = () => {
	const [resetField, setResetField] = useState('');
	const [fields, setfields] = useState<any[]>([
		{
			label: 'Valor del vehículo ',
			defaultValue: '',
			name: FORM.VEHICLE_VALUE,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '$',
			mask: 'money',
			placeholder: ' Ej: 9.000.000',
			validation: yup
				.number()
				.required('Campo Requerido')
				.typeError('Campo Requerido')
				.min(3000000, 'Ingrese un valor superior a 3.000.000'),
		} as TextFieldLayoutItem,
		{
			defaultValue: '',
			label: 'Año del vehículo',
			name: FORM.VEHICLE_YEAR,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [
				{
					label: '2022',
					value: '2022',
				},
				{
					label: '2021',
					value: '2021',
				},
				{
					label: '2020',
					value: '2020',
				},
				{
					label: '2019',
					value: '2019',
				},
				{
					label: '2018',
					value: '2018',
				},
				{
					label: '2017',
					value: '2017',
				},
				{
					label: '2016',
					value: '2016',
				},
				{
					label: '2015',
					value: '2015',
				},
				{
					label: '2014',
					value: '2014',
				},
			],
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			defaultValue: '',
			label: 'Nº de cuotas',
			name: FORM.INSTALLMENT_NUMBER,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [
				{
					label: '24',
					value: '24',
				},
				{
					label: '36',
					value: '36',
				},
				{
					label: '48',
					value: '48',
				},
			],
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
		{
			defaultValue: '',
			label: '% de pie',
			name: FORM.DOWN_PAYMENT,
			type: LAYOUT_ITEM.TYPE.SELECT,
			options: [],
			validation: yup.string().required('Campo Requerido'),
		} as SelectLayoutItem,
	]);

	const setDownPayment = (vehicleValue: number, vehicleYear: number) => {
		let newFields = fields;
		newFields[3].options =
			vehicleValue >= 5000000 ? calculateDownPaymentPercent(vehicleValue, vehicleYear) : [];
		setfields(newFields);
		setResetField(FORM.DOWN_PAYMENT);
	};


	return (
		<div>
			<MultiFormCardHeader
				title="¡Vuelve a simular tu cuota!"
				body="Modifica la información de tu simulación para otener un nuevo valor de cuota."
			/>
						<CreateFormLayout
				key={fields.length}
				fields={fields}
				resetField={resetField}
				watchField={[FORM.VEHICLE_VALUE, FORM.VEHICLE_YEAR]}
				customEvent={(values) => {
					if (values.vehicleValue && values.vehicleYear) {
						setDownPayment(parseInt(values.vehicleValue), parseInt(values.vehicleYear));
					}
				}}
			/>
		</div>
	);
};
